import { useState, useCallback } from "react"
import { validate } from "utils/validate"

export default function useForm(initVal, validations) {
  const [values, setValues] = useState(initVal)
  const [errors, setErrors] = useState({})
  const [isValid, setIsValid] = useState(false)
  const [updated, setUpdated] = useState({})

  const onChange = useCallback(
    async (evt) => {
      const { name, value } = evt.target

      if (validations) {
        const newValues = { ...values, [name]: value }

        handleValidate(newValues)
      }

      setValues((values) => ({ ...values, [name]: value }))
      setUpdated((updated) => ({ ...updated, [name]: true }))
    },
    [validations, values]
  )

  const handleValidate = (values) => {
    const { isValid, errors } = validate(validations, values)

    setErrors(errors)
    setIsValid(isValid)
  }

  const handleErrorTrigger = () => {
    handleValidate(values)

    for (const [k, _] of Object.entries(values)) {
      setUpdated((updated) => ({ ...updated, [k]: true }))
    }
  }

  const handleResetInput = useCallback(() => {
    setValues(initVal)
    setErrors({})
    setUpdated({})
    setIsValid(false)
  })

  const handleAddError = (name, errorMessage) => {
    setErrors((errors) => ({ ...errors, [name]: errorMessage }))
  }

  const handleSetValue = (vals) => {
    handleValidate(vals)
    setValues({ ...values, ...vals })
    for (const [k, _] of Object.entries(vals)) {
      if (vals[k]) {
        setUpdated((updated) => ({ ...updated, [k]: true }))
      }
    }
  }

  return {
    values,
    errors,
    isValid,
    updated,
    onChange,
    handleAddError,
    handleErrorTrigger,
    handleResetInput,
    handleSetValue,
  }
}
